import React, { useState, useEffect } from 'react';
import { Fragment } from 'react';
import Tablereact from '../common/tabulator/tablereact'
import Button from 'react-bootstrap-button-loader';
import { toast } from 'react-toastify';
import Loader from '../common/loaderapp';
import Dropzone from "react-dropzone-uploader";

const Marcas = () => {
    const [page, setPage] = useState(-1);
    const [look, setLook] = useState(false);
    const [datos, setDatos] = useState([]);
    const [nombre, setNombre] = useState('');
    const [imagen, setImagen] = useState('');
    const [filename, setFilename] = useState('');
    const [load, setLoad] = useState(false);
    const [logoActual, setLogoActual] = useState('');
    const [imageCacheKey, setImageCacheKey] = useState(Date.now());
    const [refreshKey, setRefreshKey] = useState(0);

    const appendCacheBuster = (url, key) => {
        if (!url) return '';
        const separator = url.includes('?') ? '&' : '?';
        return `${url}${separator}v=${key}`;
    };

    useEffect(() => {
        fetch('/p_marca', { method: 'GET', headers: {'Content-Type': 'application/json'} })
        .then(res => res.json())
        .then(res => {
            const items = Array.isArray(res) ? res : [];
            const mapped = items.map(item => ({
                ...item,
                LOGO_URL_RENDER: appendCacheBuster(item.LOGO_URL, imageCacheKey)
            }));
            setDatos(mapped);
            setLoad(true);
        })
        .catch(err => {console.log('Error: '+err);setLook(false)})
    }, [look, refreshKey, imageCacheKey]);

    const cabecera = [
        { Header: <b>Id</b>, accessor: 'ID', style: { textAlign: 'center'}, width:'100px', editable:true , show:false},
        { Header: <b>Imagen</b>, accessor: 'LOGO_URL_RENDER', style: { textAlign: 'center'}, width:'200px', editable:false , show:true, cell: ({ value }) => value ? <img src={value} alt="Logo" onError={(e) => { e.target.onerror = null; e.target.src = 'https://lprefacciones.mx/img/default-image.png'; }} style={{ height: 40 }} /> : 'Sin logo' },
        { Header: <b>Nombre</b>, accessor: 'NOMBRE', style: { textAlign: 'center'}, width:'Auto', editable:true , show:true},
        
    ];

    const agregar = () => {
        setPage(0);
        setNombre('');
        setImagen('');
        setFilename('');
        setLogoActual('');
    };

    const actualizar = (dato) => {
        setPage(dato.ID)
        setNombre(dato.NOMBRE)
        setImagen('') 
        setFilename('')
        setLogoActual(appendCacheBuster(dato.LOGO_URL, imageCacheKey))
    }

    const regresar = () => {
        setPage(-1);
        setNombre('');
        setImagen('');
        setFilename('');
        setLogoActual('');
        setImageCacheKey(Date.now());
        setRefreshKey(prev => prev + 1);
    }

    const eliminar = (dato) => {
        setLook(true);
        fetch('/p_marca', { method: 'DELETE', body: JSON.stringify({ID:dato.ID}), headers: {'Content-Type': 'application/json'} })
        .then(res => res.json())
        .then(res => {
            setDatos(Array.isArray(res) ? res : []);
            setLook(false);
        })
        .catch(err => {console.log('Error: '+err);setLook(false)})
    }

    const getMarcaDeleteWarning = (item = {}) => {
        const totalProductos = Number(item.TOTAL_PRODUCTOS ?? item.total_productos ?? 0);
        if (totalProductos <= 0) return null;
        return `Al desactivar esta marca también se desactivarán ${totalProductos === 1 ? '1 producto' : `${totalProductos} productos`} relacionados.`;
    };

    const insetar_actualizar = () => {
        if(nombre.trim().length === 0){
            toast.warn(`Asigna un nombre de marca.`,{ position: toast.POSITION.BOTTOM_RIGHT });
            return;
        }

        if(page === 0 && imagen === ''){
            toast.warn(`Debes subir un logo de marca.`,{ position: toast.POSITION.BOTTOM_RIGHT });
            return;
        }

        setLook(true)

        fetch('/p_marca', { 
            method: page === 0 ? 'POST':'PUT',
            body: JSON.stringify({ID:page, nombre, imagen, filename}),
            headers: {'Content-Type': 'application/json'}
        })
        .then(res => {
            setImageCacheKey(Date.now());
            setRefreshKey(prev => prev + 1);
            setLook(false);
            setPage(-1); 
            setNombre('');
            setImagen('');
            setFilename('');
            setLogoActual('');
        })
        .catch(err => {console.log('Error: '+err);setLook(false)})
    }

    const changeDropzone = ({ meta, file }, status) => {

        if(status === "preparing" || status === "done"){
            const reader = new FileReader();

            reader.onloadend = () => {
                setImagen(reader.result);
                setFilename(meta.name);
                toast.success("Imagen cargada correctamente");
            };

            reader.readAsDataURL(file);
        }

        if(status === "removed"){
            setImagen('');
            setFilename('');
        }

        if(status === "error_file_size"){
            toast.warn("La imagen debe ser menor a 1MB");
        }
    };

    const EmptyPreview = () => null;

    const hasPreview = Boolean(imagen || logoActual);

    const dropzoneStyles = (showPreview) => ({
        dropzone: {
            border: '2px dashed #4c1a7f',
            borderRadius: '12px',
            minHeight: '140px',
            overflow: 'visible'
        },
        inputLabel: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100px',
            borderRadius: '12px',
            background: showPreview ? '#DCD5EB' : '#fafaff',
            padding: '12px',
            overflow: 'hidden'
        },
        inputLabelWithFiles: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100px',
            borderRadius: '12px',
            background: '#DCD5EB',
            padding: '12px',
            overflow: 'hidden'
        }
    })

    const renderDropzoneContent = () => (
        <div className="text-center w-100">
            <i className="ti-cloud-up d-block mb-2" style={{ fontSize: '28px', color: '#E91E63' }}></i>
            <p className="mb-0 font-weight-bold">Arrastra o haz clic para subir el logo</p>
            <small className="text-muted d-block">Formatos PNG/JPG - Máximo 1MB</small>
        </div>
    )

    const renderDropzoneContentWithFile = () => (
        <div className="text-center w-100" />
    )

    const drop = () => (
        <Fragment>
            <div className="col-md-12 mb-4">
                <div className="row justify-content-center mt-3">
                    <div className="col-4 text-center">
                        <i className="ti-image" style={{ color: '#E91E63', fontSize: '24px' }}></i>
                        <h3 className="mb-0" style={{ color: '#000082', fontSize: '18px', fontWeight: 'bold' }}>Formatos requeridos:</h3>
                        <p className="mb-0" style={{ fontSize: '14px' }}>.PNG, .JPG</p>
                    </div>
                    <div className="col-4 text-center">
                        <i className="ti-control-forward" style={{ color: '#E91E63', fontSize: '24px' }}></i>
                        <h3 className="mb-0" style={{ color: '#000082', fontSize: '18px', fontWeight: 'bold' }}>Medidas recomendadas:</h3>
                        <p className="mb-0" style={{ fontSize: '14px' }}>259 × 117 px</p>
                    </div>
                    <div className="col-4 text-center">
                        <i className="ti-video-camera" style={{ color: '#E91E63', fontSize: '24px' }}></i>
                        <h3 className="mb-0" style={{ color: '#000082', fontSize: '18px', fontWeight: 'bold' }}>Peso requerido:</h3>
                        <p className="mb-0" style={{ fontSize: '14px' }}>Maximo 1Mb</p>
                    </div>
                </div>
            </div>

            <div style={{ position: 'relative' }}>
                <Dropzone
                    onChangeStatus={changeDropzone}
                    accept=".jpg,.jpeg,.png"
                    maxFiles={1}
                    multiple={false}
                    maxSizeBytes={2097152}
                    PreviewComponent={EmptyPreview}
                    inputContent={hasPreview ? renderDropzoneContentWithFile() : renderDropzoneContent()}
                    inputWithFilesContent={renderDropzoneContentWithFile()}
                    styles={dropzoneStyles(hasPreview)}
                />
                {(imagen || logoActual) && (
                    <div
                        style={{
                            position: 'absolute',
                            top: 20,
                            bottom: 20,
                            left: 20,
                            right: 20,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            pointerEvents: 'none'
                        }}
                    >
                        <img
                            src={imagen || logoActual}
                            alt="Vista previa del logo"
                            style={{ maxHeight: '140px', width: 'auto', objectFit: 'contain', borderRadius: '8px', boxShadow: '0 6px 18px rgba(0,0,0,0.08)' }}
                        />
                    </div>
                )}
            </div>
        </Fragment>
    );

    return (
        <div className="col-sm-12">
            <div className="card">
                {
                    load ?
                    (
                        page === -1 ?
                        <Fragment>
                            <div className="card-body datatable-react">
                                <Tablereact
                                    myData={datos}
                                    cabecera={cabecera}
                                    pageSize={10}
                                    paginacion={true}
                                    buscador='Buscar'
                                    boton={{text:'Agregar Marca',function:agregar}}
                                    eliminar_actualizar={{actualizar:actualizar,eliminar:eliminar}}
                                    renderDeleteWarning={getMarcaDeleteWarning}
                                />
                            </div>
                        </Fragment>
                        :
                        
                        <Fragment>
                            <div className="card-header" style={{padding:'15px'}}>
                                <button className="btn btn-outline-light-2x txt-dark" onClick={regresar} disabled={look}>
                                    <i className="icofont icofont-arrow-left"/>Regresar
                                </button>
                            </div>

                            <h4 className="mt-3 ml-4">
                                <strong>{page==0 ? 'Agregar':'Actualizar'} Marca</strong>
                            </h4>

                            <div className="card-body">
                                <div className="row">
                                    
                                    {}
                                    <div className="col-12">
                                        <div className="form-group">
                                            <label className={`form-label`}>Marca</label>
                                            <input 
                                                name={`nombre`} 
                                                value={nombre} 
                                                onChange={(e)=>setNombre(e.target.value)} 
                                                className={`form-control`} 
                                                type="text" 
                                                autoComplete="off"
                                            />
                                        </div>
                                    </div>

                                    {}
                                    <div className="col-12 mt-3">
                                        {drop()}
                                    </div>

                                </div>

                                <div className="col-md-12 mt-4">
                                    <div className="text-right">
                                        <Button className='btn-lg mr-4' onClick={insetar_actualizar} loading={look}>
                                            Guardar
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Fragment>
                    )
                    :
                    <Loader/>
                }
            </div>
        </div>
    );
}
 
export default Marcas;
